import React from "react";
import Select from "react-select";

const ListGroup = ({ option, selectedCategoryHandler }) => {
  return <Select options={option} onChange={(e) => selectedCategoryHandler(e.value)}/>;
};

export default ListGroup;
